module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-28.565fc677.png";